import uuid from 'react-uuid';
import LecturePageRootSingleton from '../services/lecture-page-root';

/* @ngInject */
export default function LectureLightHeaderCtrl(
  $scope,
  $timeout,
) {
  const vm = this;

  const lectureUpdateUUID = uuid();

  LecturePageRootSingleton.registerLectureUpdatedCB(lectureUpdateUUID, () => {
    $timeout(() => {
      vm.currentLecture = LecturePageRootSingleton.currentLecture;
    });
  });

  $scope.$on('$destroy', () => {
    LecturePageRootSingleton.unregisterLectureUpdatedCB(lectureUpdateUUID);
  });
}
